import { api } from "./api";

interface TestStatus {
    CoGuid: string;
    progress: "NotStarted" | "InProgress" | "Complete" | string;
}

export const selfPacedHomeApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getSelfPacedOverallProgress: builder.query<any, { Userid: string, Productcode: string, Offeringcode: number }>({
            query: (args) => {
                const { Userid, Productcode, Offeringcode } = args;
                return {
                    url: "/Home/OverallProgress",
                    method: "GET",
                    params: {
                        Userid: Userid,
                        Productcode: Productcode,
                        Offeringcode: Offeringcode
                    },
                }
            },
            providesTags: ["SelfPacedOverallProgress"]
        }),
        getSelfPacedPerformanceByTopic: builder.query<any, void>({
            query: () => ({
                url: "/Home/PerformanceByTopic",
                method: "GET",
            })
        }),
        getSelfPacedTestScoresAndPerformance: builder.query<any, void>({
            query: () => ({
                url: "/Home/TestScoresAndPerformance",
                method: "GET",
            })
        }),
        getSelfPacedPerformanceByTest: builder.query<any, void>({
            query: () => ({
                url: "/Home/PerformanceByTest",
                method: "GET",
            })
        }),
        getSelfPacedCoursework: builder.query<any, { page: number, selectedOption: number }>({
            query: (arg) => {
                const { page, selectedOption } = arg;
                return {
                    url: "/Home/Coursework",
                    params: { page, filter: selectedOption - 1 },
                    method: "GET",
                }
            },
            providesTags: ["SelfPacedCoursework"]
        }),
        updateSelfPacedStatus: builder.mutation<any, TestStatus>({
            query: (body) => ({
                url: "/Home/UpdateStatus",
                body: body,
                method: "PUT",
            }),
            invalidatesTags: ["SelfPacedHome", "SelfPacedCoursework"]
        }),
        viewSelfPacedPrepInfo: builder.query<any, void>({
            query: () => {
                return {
                    url: "/Home/ViewPrepInfo",
                    method: "GET",
                }
            }
        }),
        addSelfPacedFeedback: builder.mutation<any, { ProductOfferingSegmentId: number, Rating: number, FeedbackText: string }>({
            query: (body) => ({
                url: "/Home/AddFeedback",
                body: body,
                method: "PUT"
            }),
            invalidatesTags: ["SelfPacedCoursework"]
        })
    })
})

export const {
    useGetSelfPacedOverallProgressQuery,
    useGetSelfPacedPerformanceByTopicQuery,
    useGetSelfPacedTestScoresAndPerformanceQuery,
    useGetSelfPacedPerformanceByTestQuery,
    useGetSelfPacedCourseworkQuery,
    useUpdateSelfPacedStatusMutation,
    useViewSelfPacedPrepInfoQuery,
    useAddSelfPacedFeedbackMutation
} = selfPacedHomeApi;